/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x10aaba from'./../../message.js';class RevisionHistoryConnectMessage extends _0x10aaba{constructor(_0x2bb032){super(),this['documentId']=_0x2bb032;}['toJSON'](){return{'documentId':this['documentId']};}static['fromJSON'](_0x4d8057){return new RevisionHistoryConnectMessage(_0x4d8057['documentId']);}}RevisionHistoryConnectMessage['TYPE']='121',RevisionHistoryConnectMessage['READABLE_TYPE_NAME']='connectToRevisionHistory',RevisionHistoryConnectMessage['DESCRIPTOR_NAME']='RevisionHistoryConnectMessage',RevisionHistoryConnectMessage['DESCRIPTOR']={'fields':{'documentId':{'type':'string','id':0x1}}};export default RevisionHistoryConnectMessage;